import { useQuery } from "@tanstack/react-query";

import { getPartnerModulesModuleModuleID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const MODULE_PARTNERS_QUERY_KEY = (moduleID: string) =>
  ["MODULE_PARTNERS_QUERY", moduleID] as const;

const DEFAULT_LIMIT = 1000;
const DEFAULT_OFFSET = 0;

export function useModulePartnersQuery(moduleID?: string) {
  return useQuery({
    queryKey: MODULE_PARTNERS_QUERY_KEY(moduleID ?? ""),
    queryFn: processResponse(() =>
      getPartnerModulesModuleModuleID(
        moduleID ?? "",
        DEFAULT_OFFSET,
        DEFAULT_LIMIT,
      ),
    ),
    enabled: !!moduleID,
  });
}
